import { RuntimeConfig, RuntimeKey, validateRuntimeConfig } from './runtime-schema.mjs';

let configuration: RuntimeConfig | undefined;

export async function loadRuntimeConfig(surface: 'main' | 'requests' = 'main'): Promise<void> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch('/runtime-config.json', {
      cache: 'no-store',
      credentials: 'same-origin',
      redirect: 'error',
      signal: controller.signal,
    });
    if (!response.ok || !response.headers.get('content-type')?.includes('application/json'))
      throw new Error('Runtime configuration is unavailable');
    const validated = validateRuntimeConfig(await response.json(), window.location.origin);
    if (validated.surface !== surface) throw new Error('Incorrect client surface');
    configuration = validated;
  } finally {
    window.clearTimeout(timeout);
  }
}

export function configValue(key: RuntimeKey): string | undefined {
  if (configuration) return configuration[key];
  // Local development and tests retain their existing environment setup.
  if (process.env.NODE_ENV === 'production')
    throw new Error('Load runtime configuration before starting the application');
  const local = {
    REACT_APP_HTTP_PROXY_URL: process.env.REACT_APP_HTTP_PROXY_URL,
    REACT_APP_PROXY_URL: process.env.REACT_APP_PROXY_URL,
    REACT_APP_ENTRA_CLIENT_ID: process.env.REACT_APP_ENTRA_CLIENT_ID,
    REACT_APP_ENTRA_AUTHORITY: process.env.REACT_APP_ENTRA_AUTHORITY,
    REACT_APP_ENTRA_KNOWN_AUTHORITY: process.env.REACT_APP_ENTRA_KNOWN_AUTHORITY,
    REACT_APP_ENTRA_API_SCOPE: process.env.REACT_APP_ENTRA_API_SCOPE,
    REACT_APP_ENTRA_REDIRECT_URI: process.env.REACT_APP_ENTRA_REDIRECT_URI,
    REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI: process.env.REACT_APP_ENTRA_POST_LOGOUT_REDIRECT_URI,
    REACT_APP_ENTRA_MAIN_APP_CLIENT_ID: process.env.REACT_APP_ENTRA_MAIN_APP_CLIENT_ID,
  };
  return local[key];
}
